import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "../../src/types/feature.types";

import { version, name } from "./package.json";
import { FeatureToken } from "../../src/constants/di";
import { featurePaths } from "./constants/paths.constant";

const TransactionListPage = lazy(() => import("./pages/TransactionList"));
const PaymentDetailsPage = lazy(() => import("./pages/PaymentDetails"));

@injectable()
@registry([{ token: FeatureToken, useClass: PaymentManagement }])
class PaymentManagement implements FeatureSetupDef {
  GetFeatureSetup(): FeatureSetup {
    return {
      version,
      namespace: name,
      featuresRoot: this.features,
      permissions: [],
      index: true
    };
  }

  private readonly features: FeatureRootRoute = {
    requiredPermissions: [],
    children: [
      {
        title: "Transaction List",
        path: featurePaths.TransactionList,
        page: TransactionListPage
      },
      {
        title: "Payment Details",
        path: featurePaths.PaymentDetails,
        page: PaymentDetailsPage
      }
    ]
  };
}

export default PaymentManagement;
